import { FontSize } from "./types";

export const sizeMapping = {
  xs: "h-6 w-6", // for extra small
  s: "h-8 w-8", // for small
  m: "h-10 w-10", // for medium
  l: "h-12 w-12", // for large
  xl: "h-14 w-14", // for extra large
};
export const alignMapping = {
  left: "justify-start",
  center: "justify-center text-center",
  right: "justify-end",
};
export const widthMapping = {
  full: "w-full",
  auto: "w-auto",
};
export const bgColorMapping = {
  primary50: "bg-primary-50",
  primary100: "bg-primary-100",
  primary200: "bg-primary-200",
  primary300: "bg-primary-300",
  primary400: "bg-primary-400",
  primary500: "bg-primary-500",
  primary600: "bg-primary-600",
  primary700: "bg-primary-700",
  primary800: "bg-primary-800",
  primary900: "bg-primary-900",
  neutral50: "bg-neutral-50",
  neutral100: "bg-neutral-100",
  neutral200: "bg-neutral-200",
  neutral300: "bg-neutral-300",
  neutral400: "bg-neutral-400",
  neutral500: "bg-neutral-500",
  neutral600: "bg-neutral-600",
  neutral700: "bg-neutral-700",
  neutral800: "bg-neutral-800",
  neutral900: "bg-neutral-900",
  red300: "bg-red-300",
  red500: "bg-red-500",
  red900: "bg-red-900",
  white: "bg-white",
};
export const textAlignMapping = {
  left: "text-left",
  center: "text-center",
  right: "text-right",
};
export const fontSizeMapping: { [key in FontSize]: string } = {
  xs: "text-[12px]",
  sm: "text-[14px]",
  base: "text-[16px]",
  lg: "text-[18px]",
  xl: "text-[20px]",
  "2xl": "text-[24px]",
  "3xl": "text-[30px]",
  "4xl": "text-[36px]",
  "5xl": "text-[48px]",
};
